import { render, staticRenderFns } from "./ActiveIngredientsFinder.vue?vue&type=template&id=3825f502"
import script from "./ActiveIngredientsFinder.vue?vue&type=script&lang=js"
export * from "./ActiveIngredientsFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports